import type { PropsWithChildren } from "react";
import { ReportsContext } from "./ReportsContext";
import type { ReportContextType } from "./reportContext.types";
import type { ReportInfo } from "../../../../../../api/types/svTypes.ts";

export const ReportsContextProvider = ({ children, ...props }: PropsWithChildren<ReportContextType<ReportInfo>>) => {
  return <ReportsContext value={props}>{children}</ReportsContext>;
};
